// All components mapping with path for internal routes

import { lazy } from "react";

const Page404 = lazy(() => import("../pages/404"));
const CreateSchool = lazy(() => import("../School/CreateSchool"));
const SchoolTable = lazy(() => import("../School/SchoolTable"));
const CreateSession = lazy(() => import("../SchoolAdmin/CreateSession"));
const CreateSection = lazy(() => import("../SchoolAdmin/CreateSection"));
const SubjectForm = lazy(() => import("../SchoolAdmin/CreateSubject"));
const TeacherProfile = lazy(() => import("../SchoolTeacher/TeacherProfile"));
const SchoolProfile = lazy(() => import("../SchoolAdmin/SchoolProfile"));
const TopSelect = lazy(() => import("../SchoolTeacher/QuestionBank/TopSelect"));
const HelpCenter = lazy(() => import("../SchoolTeacher/HelpCenter/HelpCenter"));
const AssignmentSummary = lazy(
  () => import("../SchoolTeacher/ReviewAssignment/AssignmentSummary"),
);
const LmsContentBuilder = lazy(
  () => import("../SchoolTeacher/Content/LmsContentBuilder"),
);

const ContentGenerationOption = lazy(
  () => import("../SchoolTeacher/Content/ContentGenerateOption"),
);

const ReplicaContentTopicChapterPage = lazy(
  () =>
    import("../SchoolTeacher/contentUpload/replicaUpload/ReplicaOfContentUploadMamual"),
);
const DescriptiveQuestion = lazy(
  () => import("../SchoolTeacher/QuestionBank/DescriptiveQuestion"),
);
const QuestionBanks = lazy(
  () => import("../SchoolTeacher/QuestionBank/QuestionBanks"),
);

const AddAssignment = lazy(
  () => import("../SchoolTeacher/Assignment/AddAssignments"),
);
const ActiveAssignments = lazy(
  () => import("../SchoolTeacher/Assignment/ActiveAssignments"),
);
const AiMcqScreen = lazy(
  () => import("../SchoolTeacher/QuestionBank/AiGeneratedQuestion/AiMcqScreen"),
);
const AIQuestionGenerator = lazy(
  () =>
    import("../SchoolTeacher/QuestionBank/AiGeneratedQuestion/AiGeneratedQuestion"),
);
const OCRQuestionGenerator = lazy(
  () =>
    import("../SchoolTeacher/QuestionBank/OcrGeneratedQuestions/OcrGeneratedQuestion"),
);
const FillTheBlanksScreen = lazy(
  () => import("../SchoolTeacher/QuestionBank/FillTheBlanksScreen"),
);
const ContentLibraryPageTwo = lazy(
  () => import("../SchoolTeacher/Content/ContentLibraryPageTwo"),
);
const TrueFalseScreen = lazy(
  () => import("../SchoolTeacher/QuestionBank/TrueFalseScreen"),
);
const MCQQuestionForm = lazy(
  () => import("../SchoolTeacher/QuestionBank/McqScreen"),
);
const QuestionGeneration = lazy(
  () => import("../SchoolTeacher/QuestionBank/QuestionGeneration"),
);
const ContentTopicChapterPage = lazy(
  () => import("../SchoolTeacher/contentUpload/ContentManual"),
);
const ContentUploadFile = lazy(
  () => import("../SchoolTeacher/contentUpload/ContentUploadFile"),
);
const ContentLibrary = lazy(
  () => import("../SchoolTeacher/Content/ContentLiabery"),
);
const StudentForm = lazy(
  () => import("../SchoolAdmin/BulkUpload/CreateStudent"),
);
const SuperAdminDashboard = lazy(
  () => import("../School/Dashboard/SuperAdminDashboard"),
);
const SchoolAdminDashboard = lazy(
  () => import("../SchoolAdmin/Dashboard/SchoolAdminDashboard"),
);
const TeacherDashboard = lazy(
  () => import("../SchoolTeacher/Dashboard/TeacherDashboard"),
);
const TeacherTable = lazy(() => import("../SchoolAdmin/Teacher/TeacherTable"));

const StudentTable = lazy(
  () => import("../SchoolAdmin/BulkUpload/StudentTable"),
);
const ProfilePage = lazy(
  () => import("../features/settings/profilesettings/index"),
);
const AssignClassSection = lazy(
  () => import("../SchoolAdmin/Teacher/AssignClassSection"),
);
const UploadSessionFile = lazy(
  () => import("../SchoolAdmin/BulkUpload/Upload"),
);
const CreateTeacher = lazy(
  () => import("../SchoolAdmin/Teacher/CreateTeacher"),
);
const AddClass = lazy(() => import("../SchoolAdmin/CreateClass"));
const Dashboard = lazy(() => import("../features/dashboard"));
const SchoolAdminForgetPassword = lazy(
  () => import("../SchoolAdmin/Auth/SchoolAdminForgetPassword"),
);

let localRole = localStorage.getItem("role");

const routes = [
  // super admin routes
  {
    path: "/super-admin/dashboard",
    component: SuperAdminDashboard,
  },
  {
    path: "/create-school",
    component: CreateSchool,
  },
  {
    path: "/edit-school/:id",
    component: CreateSchool,
  },
  {
    path: "/get-school",
    component: SchoolTable,
  },

  // school admin routes
  {
    path: "/school-admin/dashboard",
    component: SchoolAdminDashboard,
  },
  {
    path: "/create-session",
    component: CreateSession,
  },
  {
    path: "/create-section",
    component: CreateSection,
  },
  {
    path: "/create-class",
    component: AddClass,
  },

  {
    path: "/create-teacher",
    component: CreateTeacher,
  },
  {
    path: "/edit-teacher/:id",
    component: CreateTeacher,
  },
  {
    path: "/get-teachers",
    component: TeacherTable,
  },
  {
    path: "/bulk-upload/students",
    component: UploadSessionFile,
  },
  {
    path: "/assign-class-section",
    component: AssignClassSection,
  },

  {
    path: "/settings-profile",
    component: ProfilePage,
  },
  {
    path: "/create-subject",
    component: SubjectForm,
  },
  {
    path: "/get-students",
    component: StudentTable,
  },
  {
    path: "/create-student",
    component: StudentForm,
  },
  {
    path: "/edit-student/:id",
    component: StudentForm,
  },
  {
    path: "/school-profile",
    component: SchoolProfile,
  },
  // school teacher routes
  {
    path: "/teacher-profile",
    component: TeacherProfile,
  },
  {
    path: "/teacher-dashboard",
    component: TeacherDashboard,
  },
  {
    path: "/content-library/page-two/:id",
    component: ContentLibraryPageTwo,
  },
  {
    path: "/content-library",
    component: ContentLibrary,
  },
  {
    path: "/content-generation/screen/:id",
    component: ContentGenerationOption,
  },
  {
    path: "/lms-content-builder/screen/:id",
    component: LmsContentBuilder,
  },
  {
    path: "/content-upload/files",
    component: ContentUploadFile,
  },
  {
    path: "/content-topic/page",
    component: ContentTopicChapterPage,
  },
  {
    path: "/question-bank",
    component: QuestionBanks,
  },
  {
    path: "/question-generation",
    component: QuestionGeneration,
  },
  {
    path: "/mcq-screen",
    component: MCQQuestionForm,
  },
  {
    path: "/mcq-screen/:id",
    component: MCQQuestionForm,
  },
  {
    path: "/true-false-screen",
    component: TrueFalseScreen,
  },
  {
    path: "/true-false-screen/:id",
    component: TrueFalseScreen,
  },
  {
    path: "/fill-the-blank/screen",
    component: FillTheBlanksScreen,
  },
  {
    path: "/fill-the-blank/screen/:id",
    component: FillTheBlanksScreen,
  },
  {
    path: "/ai-generated/screen",
    component: AIQuestionGenerator,
  },
  {
    path: "/ocr-generated/screen",
    component: OCRQuestionGenerator,
  },
  {
    path: "/ai-mcq/screen",
    component: AiMcqScreen,
  },
  {
    path: "/active-assignment/screen",
    component: ActiveAssignments,
  },
  {
    path: "/add-assignment/screen",
    component: AddAssignment,
  },

  {
    path: "/descriptive-question/screen",
    component: DescriptiveQuestion,
  },
  {
    path: "/descriptive-question/screen/:id",
    component: DescriptiveQuestion,
  },
  {
    path: "/questions-screen",
    component: TopSelect,
  },

  {
    path: "/replica-content-management",
    component: ReplicaContentTopicChapterPage,
  },
  {
    path: "/review-assignment/summary",
    component: AssignmentSummary,
  },
  {
    path: "/teacher-help-center/screen",
    component: HelpCenter,
  },
  {
    path: "/404",
    component: Page404,
  },
];

export default routes;
